import { render, staticRenderFns } from "./BucketManagementModal.vue?vue&type=template&id=10f70552&"
import script from "./BucketManagementModal.vue?vue&type=script&lang=js&"
export * from "./BucketManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./BucketManagementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports